import * as C from '@/consts'
import component from '@/libs/component'

const Top = () => import(/* webpackChunkName: "published" */ './Top')
const CarList = () => import(/* webpackChunkName: "published" */ './CarList')
const Car = () => import(/* webpackChunkName: "published" */ './Car')
const Availability = () => import(/* webpackChunkName: "published" */ './Availability')

export default [
  {
    path: '',
    name: 'top',
    ...component(Top),
    meta: {
      type: C.PAGE_PUBLISHED
    }
  },
  {
    path: 'companys/:cid',
    redirect: route => ({ name: 'top', query: { c: route.params.cid } })
  },
  {
    path: 'shops/:sid',
    redirect: route => ({ name: 'top', query: { s: route.params.sid } })
  },
  {
    path: 'stations/:stid/availability',
    name: 'availability',
    ...component(Availability),
    meta: {
      type: C.PAGE_PUBLISHED
    }
  },
  {
    path: 'stations/:stid/cars',
    name: 'cars',
    ...component(CarList),
    meta: {
      type: C.PAGE_PUBLISHED
    }
  },
  {
    path: 'stations/:stid/cars/:carid',
    name: 'car',
    ...component(Car),
    meta: {
      type: C.PAGE_PUBLISHED
    }
  }
]
